// @flow
import React from 'react'
import IconRefresh from '../icons/IconRefresh'

type Props = {
  analysisInProgress: boolean,
  onRefreshClick: Function
}

export default class RefreshAnalysisButton extends React.Component<Props> {
  render () {
    return <IconRefresh
      width='12' height='12'
      analysisInProgress={this.props.analysisInProgress}
      onClick={this.props.onRefreshClick}
    />
  }
}



// WEBPACK FOOTER //
// ./app/javascript/packs/components/shared/Header/RefreshAnalysisButton.js